import common from './common';
import home from './home';
import login from './login';
import cateringAdmin from './cateringAdmin';
import organizationAdmin from './organizationAdmin';
import educationAdmin from './educationAdmin';
import operationAdmin from './operationAdmin';
import schoolAdmin from './schoolAdmin';
import daycare from './daycare';

const OTHERAPI = [
  home,
  login,
  cateringAdmin,
  organizationAdmin,
  educationAdmin,
  operationAdmin,
  schoolAdmin,
  daycare
];

export default Object.assign(common, ...OTHERAPI);
